import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'


export default function ProtectedRoutes() {
    let loggedInUser = JSON.parse(localStorage.getItem('user_pmo'))
    if (loggedInUser === null) {
        return <Navigate to='/' replace />;
    }

    return <Outlet />;
}
